import styled from "styled-components";
import { FontSize, FontWeight } from "../../themes";
import { Header } from "antd/es/layout/layout";

interface IHeaderProps {
    align: string;
}

const HeaderContainer = styled(Header)`
    background: transparent;
    margin: 0 16px;
    padding: 0 24px;
    padding-left: 0;
    margin-left: 0;
    padding-right: 0;
    margin-right: 0;
    display: flex;
    @media (max-width: 575px) {
        height: 48px;
    }
    align-items: center;
    background-color: var(--header-background);
`;

const InputIconWrapper = styled.div`
    display: flex;
    width: 100%;
    max-width: 58px;
    align-items: center;
    font-size: 20px;

    @media (max-width: 768px) {
        padding-left: 20px;
    }
`;

const IconsContainer = styled.div`
    display: flex;
    gap: 20px;

    @media (max-width: 768px) {
        gap: 0px;
    }

    @media (max-width: 575px) {
        gap: 0;
        margin-top: 3px !important;
    }
    @media (max-width: 480px) {
        margin-top: 7px !important;
    }
`;
const HeaderUserWrapper = styled.div`
    display: flex;
    gap: 10px;
    padding: 8px;
    align-items: center;
    position: relative;

    &:hover > div > div {
        display: block;
    }

    @media (max-width: 768px) {
        gap: 5px;
        padding: 0;
    }

    @media (max-width: 480px) {
        gap: 0;
        padding: 0;
    }
`;

const HeaderUserFullNameWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-right: 5px;
`;

const HeaderUserPosition = styled.p<IHeaderProps>`
    color: var(--secondary-text);

    text-align: ${({ align = "right" }) => align};
    font-family: Poppins;
    font-size: ${FontSize.mg};
    font-style: normal;
    font-weight: ${FontWeight.medium};
    line-height: normal;
    @media (max-width: 575px) {
        font-size: 12px;
        display: none !important;
    }

    @media (max-width: 480px) {
        font-size: 10px;
    }
`;

const LightMode = styled.p<IHeaderProps>`
    color: var(--secondary-text);

    text-align: ${({ align = "right" }) => align};
    font-family: Poppins;
    font-size: ${FontSize.mg};
    font-style: normal;
    font-weight: ${FontWeight.medium};
    line-height: normal;
`;

const UserImageWrapper = styled.img`
    width: 50px;
    height: 50px;
    border-radius: 50%;

    @media (max-width: 768px) {
        width: 40px;
        height: 40px;
    }

    @media (max-width: 480px) {
        width: 35px;
        height: 35px;
    }
`;

const HeaderUserInformationWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 20px;
`;

const HeaderSearchButtonWrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    max-width: 386px;
    width: 100%;

    @media (max-width: 575px) {
        display: none;
    }
`;

const HeaderUserSettingContainer = styled.div`
    position: relative;
`;

const DesktopMenuClick = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    @media (max-width: 700px) {
        display: none;
    }
`;

const MbOpenClick = styled.div`
    display: none;

    @media (max-width: 700px) {
        display: flex;

        cursor: pointer;
    }
`;
export {
    HeaderUserWrapper,
    HeaderUserFullNameWrapper,
    MbOpenClick,
    HeaderUserPosition,
    UserImageWrapper,
    HeaderContainer,
    InputIconWrapper,
    HeaderSearchButtonWrapper,
    HeaderUserInformationWrapper,
    HeaderUserSettingContainer,
    IconsContainer,
    DesktopMenuClick,
    LightMode,
};
